const schema = {
    nomeArquivo: {
        id: 'nomeArquivo',
        label: '',
        placeholder: 'Nome do arquivo',
        type: 'text',
    },
    typeFile: {
        id: 'typeFile',
        label: '',
        value: 'C',
        type: 'select',
    },
    movementRef: {
        id: 'movementRef',
        label: '',
        placeholder: 'Mês de referência',
        type: 'text',
    },
    movementDate: {
        id: 'movementDate',
        label: '',
        placeholder: ['Período', ''],
        type: 'daterange',
    },
    movementStatus: {
        id: 'movementStatus',
        label: '',
        placeholder: 'Status',
        type: 'select',
    },
};

export default schema;
